import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { ApiCall } from '../../../Services/utils/ApiCall';
import { baseURL, utilityBaseURL } from '../../../Services/config/apiGateway';
import {
    PROFILE_ENDPOINT, VALIDATE_OTP_ENDPOINT, COUNTRY_ENDPOINT,
    GENERATE_OTP_ENDPOINT
} from '../../../Services/config/apiEndPoints';
import { Image } from 'react-bootstrap';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import Input from '../../Shared/Input';
import CountryCodeModal from '../../Shared/CountryCodeModal';
import '../../../css/ProfileManagement/VerifyMobile.css';
import arrowdown from '../../../Assets/UserAccess/Desktop/arrow-down.svg';
import arrowup from '../../../Assets/UserAccess/Desktop/arrow-up.svg';
import search from '../../../Assets/UserAccess/image/search.svg';
import save from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-left.svg';
import saveEnable from '../../../Assets/ProfileManagement/Assets-Desktop/userprofile.svg';
import edit from '../../../Assets/ProfileManagement/Assets-Desktop/edit.svg';
import editenable from '../../../Assets/ProfileManagement/Assets-Desktop/editenable.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../css/ProfileManagement/Modal.css';
import AddProfileModal from '../../Shared/GenericModalError';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
// for redux
import { useSelector } from 'react-redux';
import { AES, enc } from 'crypto-js';

const VerifyMobile = () => {
    const container = React.createRef();
    const paramObj = useParams();
    const userProfileDataR = useSelector(state => JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8)));
    const [userData, setUserData] = useState({});
    let history = useHistory();
    const [isEdit, setIsEdit] = useState(false);
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [username, setUsername] = useState('');
    const [verifyCode, setVerifyCode] = useState('');
    let [usernameerror, setUsernameerror] = useState();
    let [countryCodeList, setCountryCodeList] = useState([]);
    const [countryCode, setCountryCode] = useState("+27");
    const [countrydropdown, setcountrydropdown] = useState(false);
    const [showcountrymodal, setshowcountrymodal] = useState(false);
    const [showVerificationCode, setShowVerificationCode] = useState(false);
    const [verificationSuccess, setVerificationSuccess] = useState(false);
    const [verificationSuccessAlert, setVerificationSuccessAlert] = useState(false);
    const [saveAlert, setSaveAlert] = useState(false);
    const [verifySaveAlert, setVerifySaveAlert] = useState(false);
    const [continueAlert, setContinueAlert] = useState(false);
    const [mobileAlreadyExist, setMobileAlreadyExist] = useState(false);
    const [showSendVCForAEMobile, setshowSendVCForAEMobile] = useState(false);
    const [mobileLength, setMobileLength] = useState(0);
    const [searchinput, setSearchinput] = useState("");
    let [firstnameerror, setFirstnameError] = useState();
    let [lastnameerror, setLastnameError] = useState();
    let [verificationCodeError, setVerificationCodeError] = useState();
    const [isSave, setIsSave] = useState(false);
    const [roleType, setRoleType] = useState('');
    const [roleName, setRoelName] = useState('');
    const [roleIdV, setRoleIdV] = useState('');
    const [profileTypeAndStatus, setProfileTypeAndStatus] = useState('');
    const [nextPagePath, setNextPagePath] = useState('');
    const [hasOpenError, setHesopenError] = useState(false);
    const [emailMessage, setEmailMessage] = useState('');
    useEffect(() => {
        const { roleId, roleTypeValue, roleNameValue, profileTypeAndStatusValue, nextPageValue } = paramObj;
        setRoleType(roleTypeValue);
        setRoelName(roleNameValue);
        setRoleIdV(roleId);
        setProfileTypeAndStatus(profileTypeAndStatusValue);
        setNextPagePath(nextPageValue);
        ApiCall(
            'GET',
            baseURL + PROFILE_ENDPOINT + `?userName=${userProfileDataR?.userEmail}`,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    setUserData(data);
                    //if mobile number already available
                    if (data?.userdetails?.user?.userMobile) {
                        localStorage.setItem('mobileVerificationDone', true);
                        setMobileAlreadyExist(true);
                        setCountryCode(data.userdetails.user?.countryCode);
                        setUsername(data.userdetails.user?.userMobile);
                        setContinueAlert(false);
                        setVerificationSuccess(true);
                    }
                }
            }
        });
    }, []);
    //countryCode API CALL
    const getCountryCode = () => {
        ApiCall(
            'GET',
            utilityBaseURL + COUNTRY_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    setCountryCodeList(apiData)
                }
            }
            else {
                console.log(`Some error occured - ${apiData.errorMessage}`);
            }
        });
    }
    const generateOtp = () => {
        ApiCall(
            'GET',
            utilityBaseURL + GENERATE_OTP_ENDPOINT + username + '/' + countryCode,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log('I am 500!');
                    alert(`${data?.data?.message}`);
                }
                else {
                    console.log('I am 200!');
                    alert(`OTP ${data.message}`);
                    console.log('otp---', data.message)
                    setShowVerificationCode(true);
                    setshowSendVCForAEMobile(false);
                }
            }
            else {
                console.log('Something went wrong!');
            }
        })
    }
    const validateOtp = () => {
        ApiCall(
            'PUT',
            utilityBaseURL + VALIDATE_OTP_ENDPOINT,
            {
                "countryCode": countryCode,
                "mobileNo": username,
                "otp": verifyCode
            },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log('I am 500!');
                    if (data.data.message === "You have exhausted all the attempts to verify the OTP. Please request a new OTP.") {
                        setEmailMessage(data.data.message);
                        setHesopenError(true);
                    } else {
                        setEmailMessage(`${data.data.errors.TPT0018} ${data.data.message}`);
                        setHesopenError(true);
                    }
                    console.log('validate--', data.data.errors.TPT0018);
                }
                else {
                    console.log('I am 200!');
                    setVerificationSuccess(true);
                    setVerificationSuccessAlert(true);
                    setContinueAlert(false);
                    setSaveAlert(false);
                    setVerifySaveAlert(false);
                    setVerifySaveAlert(false);
                    console.log("verifyOTPCode");
                }
            }
            else {
                console.log(`Something went wrong`);
            }
        })
    }
    const EditValue = () => {
        setIsEdit(true);
        //calling country code api
        getCountryCode();
        setContinueAlert(false);
        if (isSave) {
            setFirstname(firstname);
            setLastname(lastname);
        } else {
            setFirstname(userData.userdetails?.user.firstName);
            setLastname(userData.userdetails?.user.lastName);
        }
        setIsSave(false);
    }
    const handleClickOutside = event => {
        if (container.current && !container.current.contains(event.target)) {
            setcountrydropdown(false);
        }
    };
    document.addEventListener("mousedown", handleClickOutside);
    const onDropdownCancel = () => {
        setcountrydropdown(false);
        setshowcountrymodal(false);
    }
    const onCloseModalEmail = () => {
        setHesopenError(false);
    };
    const handleChangeUsername = (e) => {
        setUsername(e.target.value);
        setMobileLength(e.target.value?.length);
        setshowSendVCForAEMobile(true);
        setShowVerificationCode(false);
        setVerificationSuccess(false);
        setVerificationSuccessAlert(false);
        setVerificationCodeError();
        setUsernameerror();
        document.getElementById('username').style.borderColor = ColorCode.colorCode.black;
        document.getElementById('basic-addon1').style.border = '1px solid #B2B2B2';
    };
    const handleChangeVerifyCode = (e) => {
        setVerifyCode(e.target.value);
        setVerificationCodeError();
        document.getElementById('verifyCode').style.border = '1px solid #B2B2B2';
    }
    const handleChangeFirstName = (e) => {
        setFirstname(e.target.value);
        setFirstnameError();
        document.getElementById('firstname').style.border = "1px solid #B2B2B2";
    }
    const handleChangeLastName = (e) => {
        setLastname(e.target.value);
        setLastnameError();
        document.getElementById('lastname').style.border = "1px solid #B2B2B2";
    }
    const handlechangeSearch = (e) => {
        setSearchinput(e.target.value);
    };
    const SaveValue = event => {
        event.preventDefault();
        if (validate()) {
            console.log("mobileLength", mobileLength);
            if (mobileLength > 0 && verificationSuccess) {
                setMobileAlreadyExist(true);
            }
            if (mobileLength === 0 || (mobileLength > 0 && verificationSuccess)) {
                ApiCall(
                    'PUT',
                    baseURL + PROFILE_ENDPOINT,
                    {
                        "accountDocument": userData.accountDocument,
                        "address": userData.address,
                        "bankDetails": userData.bankDetails,
                        "companyDetails": userData.companyDetails,
                        "drivingLicenseDetails": userData.drivingLicenseDetails,
                        "identityDetails": userData.identityDetails,
                        "profileRoles": userData.profileRoles,
                        "userdetails": {
                            "profilePicture": "string",
                            "user": {
                                "companyName": "string",
                                "countryCode": countryCode,
                                "employeeId": userData.userdetails.id,
                                "firstName": firstname,
                                "lastName": lastname,
                                "userEmail": userData.userdetails?.user.userEmail,
                                "userMobile": username,
                            },
                            "userType": userData.userdetails?.userType,
                            "username": userData.userdetails?.username
                        }
                    },
                    {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    }
                ).then(data => {
                    if (data.flag != -1) {
                        console.log('I am 200!');
                        // use for secure routing
                        if (verificationSuccess) {
                            localStorage.setItem('mobileVerificationDone', true);
                        }
                        setFirstname(firstname);
                        setLastname(lastname);
                        setUsername(username);
                        setCountryCode(countryCode);
                        setIsEdit(false);
                        setIsSave(true);
                        setSaveAlert(false);
                    }
                })
            }
            else {
                setVerifySaveAlert(true);
                setContinueAlert(false);
                setSaveAlert(false);
                setVerificationSuccessAlert(false);
            }
        }
    }
    const handleKeyDown = event => {
        if (event.key === " ") {
            event.preventDefault();
        }
    };
    const sendVerificationCode = event => {
        event.preventDefault();
        if (validateMobile()) {
            setVerifyCode('');
            generateOtp();
        }
    }
    const verifyOTPCode = event => {
        event.preventDefault();
        if (validateVerificationCode()) {
            validateOtp();
        }
    }
    const resendOTPCode = event => {
        event.preventDefault();
        generateOtp();
        console.log("resendOTPCode");
    }
    const validateMobile = () => {
        let contactNumber = username.toString().replace(/^0+/, "");
        setUsername(username.toString().replace(/^0+/, ""));
        let isValid = true;
        var pattern = new RegExp(/^[0-9\b]+$/);
        var globalContact = new RegExp(/^((?:\+27|27)|0)(\d{2})-?(\d{3})-?(\d{4})$/);
        if (!username) {
            isValid = false;
            usernameerror = Message.validation.required;
            document.getElementById('username').style.borderColor = ColorCode.colorCode.red;
            document.getElementById('basic-addon1').style.border = '1px solid #841300';
        } else if (!pattern.test(username)) {
            isValid = false;
            usernameerror = Message.validation.num;
            document.getElementById('username').style.borderColor = ColorCode.colorCode.red;
            document.getElementById('basic-addon1').style.border = '1px solid #841300';
        }
        //south africa contact validation
        else if (countryCode == "+27" && !globalContact.test(countryCode + contactNumber)) {
            console.log("global regex contact", countryCode + username);
            isValid = false;
            usernameerror = "Please enter valid mobile number";
            document.getElementById('username').style.borderColor = '#841300';
            document.getElementById('basic-addon1').style.border = '1px solid #841300';
        }
        else if (contactNumber?.length < 6 || contactNumber?.length > 16) {
            isValid = false;
            usernameerror = Message.validation.mobile;
            document.getElementById('username').style.borderColor = ColorCode.colorCode.red;
            document.getElementById('basic-addon1').style.border = '1px solid #841300';
        }
        else {
            document.getElementById('username').style.borderColor = ColorCode.colorCode.black;
            document.getElementById('basic-addon1').style.border = '1px solid #B2B2B2';
        }
        setUsernameerror(usernameerror);
        return isValid;
    }
    const validateVerificationCode = () => {
        let isValid = true;
        var patternDigit = new RegExp(/^[0-9\b]+$/);
        if (!verifyCode) {
            isValid = false;
            verificationCodeError = Message.validation.required;
            document.getElementById('verifyCode').style.border = "1px solid #841300";
        } else if (!patternDigit.test(verifyCode)) {
            isValid = false;
            verificationCodeError = Message.validation.num;
            document.getElementById('verifyCode').style.border = "1px solid #841300";
        } else {
            document.getElementById('verifyCode').style.border = "1px solid #B2B2B2";
        }
        setVerificationCodeError(verificationCodeError);
        return isValid;
    }
    const validate = () => {
        var patternCharacter = new RegExp(/^[a-zA-Z ]*$/);
        let isValid = true;
        if (!firstname) {
            isValid = false;
            firstnameerror = Message.validation.required;
            document.getElementById('firstname').style.border = "1px solid #841300";
        } else if (!patternCharacter.test(firstname)) {
            isValid = false;
            firstnameerror = Message.validation.alpha;
            document.getElementById('firstname').style.border = "1px solid #841300";
        } else {
            document.getElementById('firstname').style.border = "1px solid #B2B2B2";
        }
        if (!lastname) {
            isValid = false;
            lastnameerror = Message.validation.required;
            document.getElementById('lastname').style.border = "1px solid #841300";
        } else if (!patternCharacter.test(lastname)) {
            isValid = false;
            lastnameerror = Message.validation.alpha;
            document.getElementById('lastname').style.border = "1px solid #841300";
        } else {
            document.getElementById('lastname').style.border = "1px solid #B2B2B2";
        }
        setFirstnameError(firstnameerror);
        setLastnameError(lastnameerror);
        return isValid;
    }
    const navidatetoAddProfile = () => {
        if (verificationSuccess) {
            //check save
            if (!isEdit) {
                if (nextPagePath === 'company-info') {
                    history.push({
                        pathname: `/CompanyInfo/${roleIdV}/${roleType}/${roleName}/${profileTypeAndStatus}`,
                    });
                }
                if (nextPagePath === 'bank-info') {
                    history.push({
                        pathname: `/bankInfo/${roleIdV}/${roleType}/${roleName}/${profileTypeAndStatus}`,
                    });
                }
                if (nextPagePath === 'id-info') {
                    history.push({
                        pathname: `/DriverProfile/${roleIdV}/${roleType}/${roleName}/${profileTypeAndStatus}`,
                    });
                }
            }
            if (isEdit) {
                setSaveAlert(true);
                setContinueAlert(false);
                setVerifySaveAlert(false);
                setVerificationSuccessAlert(false);
            }
        } else {
            setContinueAlert(true);
            setSaveAlert(false);
            setVerifySaveAlert(false);
            setVerificationSuccessAlert(false);
        }
    };
    const changeCountryCode = (event) => {
        const found = countryCodeList?.find((name) => {
            if (name.dial_code === event.target.innerText || name.name === event.target.innerText) {
                return name
            }
        })
        setCountryCode(found?.dial_code);
        setShowVerificationCode(false);
        setshowSendVCForAEMobile(true);
        setVerificationSuccess(false);
        setVerificationSuccessAlert(false);
        setVerificationCodeError();
        setUsernameerror();
        document.getElementById('username').style.borderColor = ColorCode.colorCode.black;
        document.getElementById('basic-addon1').style.border = '1px solid #B2B2B2';
        setcountrydropdown(false);
        setshowcountrymodal(false);
    };
    const toggleCountrySearchDropdown = () => {
        setcountrydropdown(!countrydropdown);
        setshowcountrymodal(!showcountrymodal);
    };
    const droparrow = (countrydropdown || showcountrymodal) ? <Image src={arrowup} /> : <Image src={arrowdown} />
    if (searchinput?.length > 0) {
        countryCodeList = countryCodeList?.filter((i) => {
            return i.name?.toLowerCase()?.includes(searchinput?.toLowerCase()) || i.dial_code?.includes(searchinput) || i.code?.toLowerCase()?.includes(searchinput?.toLowerCase());
        });
    }
    return (
        <div>
            <div class="h1fullon">
                <MetaDecorator title={TitleDescription.verifyEmailPageTitle} description={TitleDescription.verifyEmailPageDescription} />
                <Header tilesFetched={() => { }} />
                <div id="h1box1">
                    <div className="navbar " class="navbar">
                        <div className="navbarname">
                            <span id="h1navc">Hello User</span>
                        </div>
                        <div class="h1navsave ">
                            <img src={isEdit ? editenable : edit} class=" mr-1 pb-1" id="editicon" alt="" loading="lazy" />
                            <a onClick={(EditValue)} id={isEdit ? "h1save" : "edit"} class=" pr-4" >Edit</a>
                            <img src={isEdit ? saveEnable : save} class=" mr-1 pb-1" id="saveicon" alt="" loading="lazy" />
                            <small onClick={SaveValue} id={isEdit ? "h1saveEnable" : "h1save"} >Save</small>
                        </div>
                    </div>
                    <hr class="hr1" />
                    <div class="hellomaincard11">
                        {
                            isEdit ?
                                <div class="hellonavcard11" >
                                    <div class="hellouserrows">
                                        <div class="hellouserrowfirst">
                                            <div class="hellouserinputfirst">
                                                <small class="name">First Name</small>
                                                <br />
                                                <input class="inputTextName"
                                                    onBlur={() =>
                                                        setFirstname(firstname?.trim())
                                                    }
                                                    id="firstname" value={firstname} onChange={handleChangeFirstName} type="text" />
                                                <div className="bankinfoerror12">{firstnameerror}</div>
                                            </div>
                                            <div class="hellouserinput11">
                                                <small class="name">Last Name</small>
                                                <br />
                                                <input class="inputTextName" id="lastname"
                                                    onBlur={() =>
                                                        setLastname(lastname?.trim())
                                                    }
                                                    value={lastname} onChange={handleChangeLastName} />
                                                <div className="bankinfoerror12">{lastnameerror}</div>
                                            </div>
                                            <div class="hellouserinput12">
                                                <small class="name">Email Address</small>
                                                <br />
                                                <small class="mobile">{userData.userdetails?.user.userEmail}</small>
                                            </div>
                                        </div>
                                        <div class="hellouserrow2">
                                            <div class="form-group" id="logspan01" style={{ marginTop: "0px" }}>
                                                <small class="text-black-50" for="exampleInputEmail1" className='loglabel'>Mobile Number</small>
                                                {!verificationSuccess ?
                                                    <div className="grp1" id="logaccl01" >
                                                        <div class="input-group-prepend" id="logaccl02">
                                                            <span class="logaccl04" id="basic-addon1">
                                                                <small class="dropspanuoter">{countryCode}</small>
                                                                <i onClick={toggleCountrySearchDropdown} id="dropspanimg" alt="">{droparrow}</i>
                                                            </span>
                                                        </div>
                                                        <div id="logaccl03" >
                                                            <Input type="text" class="logininpradius" id="username" name="username" autoComplete="off"
                                                                value={username} onKeyDown={handleKeyDown} onChange={handleChangeUsername} />
                                                        </div>
                                                    </div>
                                                    :
                                                    <div>
                                                        {/*Check mobile already exist */}
                                                        {mobileAlreadyExist ?
                                                            <div>
                                                                <div className="grp1" id="logaccl01" >
                                                                    <div class="input-group-prepend" id="logaccl02">
                                                                        <span class="logaccl04" id="basic-addon1">
                                                                            <small class="dropspanuoter">{countryCode}</small>
                                                                            <i onClick={toggleCountrySearchDropdown} id="dropspanimg" alt="">{droparrow}</i>
                                                                        </span>
                                                                    </div>
                                                                    <div id="logaccl03" >
                                                                        <Input type="text" class="logininpradius" id="username" name="username" autoComplete="off"
                                                                            value={username} onKeyDown={handleKeyDown} onChange={handleChangeUsername} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            :
                                                            <div class="VerifiedMobileNumber">
                                                                <small class="verifiedCountryCode">{countryCode}</small>
                                                                <img src={arrowdown} id="verifiedDropArrow" height="20" width="20" alt="" />
                                                                <small class="verifiedMobile">{username}</small>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                <div className={countrydropdown || showcountrymodal || verificationSuccess ? "nodisplay" : "error12"}>{usernameerror}</div>
                                                {countrydropdown && (
                                                    <div class="VerifyCountryDivOuter" id="DisplayCountryCodeDropDown">
                                                        <div class="logdrop01">
                                                            <div class="upperDivDrop">
                                                                <div class="down" id="VerifyCountryDivOuter" ref={container} style={{ position: "relative" }}>
                                                                    <div class="down" id="VerifyMobileCountryCodeDropDown" ref={container} style={{ position: "relative" }}>
                                                                        <div class="p-2">
                                                                            <div className="pass-wrapper" class="searchout">
                                                                                <Input id="searchinputdrop" name="password1" placeholder="Search Country" autoComplete="off"
                                                                                    onChange={handlechangeSearch} value={searchinput} />
                                                                                <img class="searchinput_img" src={search} />
                                                                            </div>
                                                                        </div>
                                                                        <div class="down2">
                                                                            {(countryCodeList?.map((player, index) => {
                                                                                return (
                                                                                    <table class="table table-white" id="logsdd002" style={{ marginBottom: "0rem" }} key={index} >
                                                                                        <tbody>
                                                                                            <tr class="top11div" onClick={(index1) => changeCountryCode(index1)}>
                                                                                                <td id="logdroptd" >
                                                                                                    <small class="p-2  " id="logdroptdleft">{player.name}</small>
                                                                                                </td>
                                                                                                <td id="logdroptd">
                                                                                                    <small class="p-2  " id="logdroptdright">{player.dial_code}</small>
                                                                                                </td>
                                                                                            </tr>
                                                                                        </tbody>
                                                                                    </table>
                                                                                );
                                                                            }))
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="VerifyMobiledropcansal" onClick={onDropdownCancel}><small class="dropcansal2">Cancel</small></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            {((!showVerificationCode && !mobileAlreadyExist) || (mobileAlreadyExist && showSendVCForAEMobile)) &&
                                                <div class="sendVerificationdiv">
                                                    <small class="sendVerification" onClick={sendVerificationCode}>Send Verification Code</small>
                                                </div>}
                                        </div>
                                        {showVerificationCode && !verificationSuccess &&
                                            <div class="hellouserrow3">
                                                <div class="hellouserinput3">
                                                    <small class="name">Verification Code</small>
                                                    <br />
                                                    <input class="inputVerifyCode" id="verifyCode" value={verifyCode} onChange={handleChangeVerifyCode} type="text" />
                                                    <div className="error12">{verificationCodeError}</div>
                                                </div>
                                                <div class={verificationCodeError ? "verifyCodeDivAfterError" : "verifyCodediv"}>
                                                    <small class="sendVerification" onClick={verifyOTPCode}>Verify Code</small>
                                                    <small class="sendVerification" onClick={resendOTPCode}>Send new code</small>
                                                </div>
                                            </div>}
                                    </div>
                                </div>
                                :
                                <div class="hellonavcard11" >
                                    <div class="hellouserrows">
                                        <div class="hellouserrowfirst">
                                            <div class="hellouserinputfirst">
                                                <small class="name">First Name</small>
                                                <br />
                                                {!isSave ? <small class="name1">{userData.userdetails?.user.firstName}</small> : <small class="name1">{firstname}</small>}
                                            </div>
                                            <div class="hellouserinput11">
                                                <small class="name">Last Name</small>
                                                <br />
                                                {!isSave ? <small class="name1">{userData.userdetails?.user.lastName}</small> : <small class="name1">{lastname}</small>}
                                            </div>
                                            <div class="hellouserinput12">
                                                <small class="name">Email Address</small>
                                                <br />
                                                <small class="mobile">{userData.userdetails?.user.userEmail}</small>
                                            </div>
                                        </div>
                                        <div class="hellouserrowMobile">
                                            <div class="hellouserinput2">
                                                <small class="name">Mobile Number</small>
                                                <br />
                                                {verificationSuccess ?
                                                    <div class="VerifiedMobileNumber">
                                                        <small class="verifiedCountryCode">{countryCode}</small>
                                                        <img src={arrowdown} id="verifiedDropArrow" height="20" width="20" alt="" />
                                                        <small class="verifiedMobile">{username}</small>
                                                    </div>
                                                    :
                                                    <div>
                                                        {mobileAlreadyExist ?
                                                            <div class="VerifiedMobileNumber">
                                                                <small class="verifiedCountryCode">{countryCode}</small>
                                                                <img src={arrowdown} id="verifiedDropArrow" height="20" width="20" alt="" />
                                                                <small class="verifiedMobile">{username}</small>
                                                            </div>
                                                            :
                                                            <small class="mobile">Not available</small>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        }
                        {continueAlert &&
                            <div class="verifyMessageDiv">
                                <small class="alertMessage">Mobile Number not verified. Please verify before continue.</small>
                            </div>
                        }
                        {saveAlert &&
                            <div class="verifyMessageDiv">
                                <small class="alertMessage">Please save before continue.</small>
                            </div>
                        }
                        {verifySaveAlert &&
                            <div class="verifyMessageDiv">
                                <small class="alertMessage">Mobile Number not verified. Please verify before save.</small>
                            </div>
                        }
                        {verificationSuccessAlert &&
                            <div class="verifyMessageDiv">
                                <small class="afterVerificationMsg">Mobile Number verified. You can now continue.</small>
                            </div>
                        }
                        <div class="bttn211">
                            <Button id="bttnVerifyMobile" class="bttn1 " onClick={navidatetoAddProfile}>Continue</Button>
                        </div>
                    </div>
                </div>
                <div class="hhhhfooter22">
                    <Footer2 />
                </div>
            </div >
            <div class="hhhhfooter11">
                <Footer />
            </div>
            {hasOpenError ? <AddProfileModal hasOpen={hasOpenError} onCloseModal={onCloseModalEmail} >
                <div>
                    <div class="successtext1outercreatepreadvise">
                        <small class="addprofilemodalsmall">{emailMessage} </small>
                    </div>
                </div>
            </AddProfileModal> : null}
            <div class="DisplayCountryCodeModal">
                {showcountrymodal ?
                    <CountryCodeModal>
                        <div class="CountryCodedivup">
                            <div class="">
                                <div className="pass-wrapper" class="CountryCodesearchout">
                                    <Input id="CountryCodesearchinputdrop" name="password1" placeholder="Search Country" autoComplete="off"
                                        onChange={handlechangeSearch} value={searchinput} />
                                    <img class="searchinput_img" src={search} />
                                </div>
                            </div>
                        </div>
                        <div class="CountryCodedivupdivmidilTabletMobile">
                            <div class="down2">
                                {(countryCodeList?.map((player, index) => {
                                    return (
                                        <table class="table table-white" id="logsdd002" style={{ marginBottom: "0rem" }} key={index} >
                                            <tbody>
                                                <tr class="top11div" onClick={(index1) => changeCountryCode(index1)}>
                                                    <td id="CountryCodelogdroptd" >
                                                        <small class="p-2  " id="CountryCodelogdroptdleft">{player.name}</small>
                                                    </td>
                                                    <td id="CountryCodelogdroptdright">
                                                        <small class="p-2  " id="CountryCodelogdroptdright">{player.dial_code}</small>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    );
                                }))
                                }
                            </div>
                        </div>
                        <div class="CountryCodedivlow" onClick={onDropdownCancel}>
                            <small class="CountryCodedivlowtext">Cancel</small>
                        </div>
                    </CountryCodeModal>
                    : null}
            </div>
        </div >
    );
}
export default VerifyMobile;
